import { Construction, FileUp } from 'lucide-react';
import { Button } from '../../design-system/Button';

const messages: Record<string, { title: string; body: string }> = {
  clean: { title: 'Privacy Clean is not available yet', body: 'Metadata, comments, macros, hidden content, and external links must not be removed until each operation has a preview, explicit selection, preservation tests, and post-clean validation.' },
  compare: { title: 'File Compare is not available yet', body: 'Good-copy and version comparison need format-aware semantic matching. MendByte will not present byte differences as meaningful document recovery.' },
  batch: { title: 'Batch processing is not available yet', body: 'Safe queueing requires bounded worker concurrency, per-file cancellation, memory-pressure handling, and honest per-file outcomes.' },
};

export function UnavailablePage({ feature, onRescue }: { feature: string; onRescue: () => void }): React.JSX.Element {
  const message = messages[feature] ?? { title: 'This module is not available yet', body: 'MendByte only exposes operations backed by tested local processing.' };
  return (
    <section className="unavailable-page">
      <Construction />
      <p className="mono label">CAPABILITY NOT ENABLED</p>
      <h1>{message.title}</h1>
      <p>{message.body}</p>
      <Button variant="primary" onClick={onRescue}><FileUp />Use MendByte Rescue</Button>
    </section>
  );
}
